import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Churches: Not just for Chicken Anymore...',
  date: new Date(2023, 4, 7),
  img: '/img/chickens.jpeg',
  tracks: [
    {
      title: 'Getting Off on The Right Foot',
      src: '/songs/2023-05-07/getting_off.mp3',
    },
    {
      title: 'High Above the Clouds',
      src: '/songs/2023-05-07/high_above_the_clouds.mp3',
    },
    {
      title: '82nd Street Cow',
      src: '/songs/2023-05-07/82nd_street_cow.mp3',
    },
    {
      title: 'Get On Down to Mexico',
      src: '/songs/2023-05-07/get_on_down_to_mexico.mp3',
    },
    {
      title: 'Hop aboard The Portland Express',
      src: '/songs/2023-05-07/hop_aboard.mp3',
    },
    {
      title: 'Fly On The Wall',
      src: '/songs/2023-05-07/fly_on_the_wall.mp3',
    },
    {
      title: 'Plug Yourself In',
      src: '/songs/2023-05-07/plug_yourself_in.mp3',
    },
    {
      title: 'Escalation',
      src: '/songs/2023-05-07/escalation.mp3',
    },
    {
      title: 'The Gateway',
      src: '/songs/2023-05-07/the_gateway.mp3',
    },
    {
      title: 'It Takes You by Surprise',
      src: '/songs/2023-05-07/it_takes_you_by_surprise.mp3',
    },
    {
      title: 'Being in Love',
      src: '/songs/2023-05-07/being_in_love.mp3'
    },
    {
      title: 'Abyssal Descent',
      src: '/songs/2023-05-07/abyssmal_descent.mp3',
    },
    {
      title: 'Hard Path to Follow',
      src: '/songs/2023-05-07/hard_path_to_follow.mp3',
    },
    {
      title: 'Survival of The Fittest',
      src: '/songs/2023-05-07/survival_of_the_fittest.mp3',
    },
    {
      title: 'The Sexy Song',
      src: '/songs/2023-05-07/the_sexy_song.mp3',
    },
  ]
}
export default album;